<header mat-dialog-title class="u-flex-full">
  <span>
    {{'bank-accounts.Seleziona conto corrente' | translate}}
  </span>
</header>
<mat-dialog-content>
  <bank-account-list [bankAccounts]="bankAccounts" [defaultFilters]="defaultFilters" [displayedColumns]="displayedColumns" [total]="total"
    [canSelect]="true" (onSortChange)="sortChange($event)" (onPageChange)="pageChange($event)"
    (onFilterChange)="filtersChange($event)" (onSelectBankAccount)="selectBankAccount($event)"></bank-account-list>
</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
